export default {
    groupName: 'comcast-premarket',
    appName: 'Comcast Pre-market',
    baseRoute: '/dashboard/comcastPremarket',
    label: 'Pre-market Ad Dashboard',
    home: '/slicer',
    image: 'comcast.png',
    description: 'Comcast Pre-Market Advertising Dashboard'
}